<template>
  <div>
    <div class="col-xs-12">
      <!-- Indicador de carga -->
      <div v-if="$apollo.loading || cargando" class="contenedor-spinner">
        <div class="spinner"></div>
      </div>
      <div class="uca-form">
        <div id="uca-form-content" class="uca-form-content row">
          <div class="col-md-offset-2 col-md-8 col-sm-offset-2 col-sm-8 col-xs-offset-1 col-xs-10 text-center">
            <div v-if="vagon === 1">
              <h2 class="form-title">Iniciar Registro</h2>
              <div class="alert alert-info text-center form-alert" role="alert">
                Para iniciar el registro, rellena tu documento de identidad (NIF/NIE/Pasaporte) <br/>
                y tu fecha de nacimiento.
              </div>
              <div class="form-group row">
                <label for="dni" class="col-xs-5 col-form-label text-right">Documento:</label>
                <div class="col-sm-5 col-xs-7 text-left">
                  <input type="text" name="dni" id="dni" aria-label="Documento" class="form-control" v-model="dni">
                </div>
              </div>
              <div class="form-group row">
                <label for="dia" class="col-xs-5 col-form-label text-right">Fecha de nacimiento:</label>
                <div class="col-sm-7 col-xs-7">
                  <div class="row">
                    <div class="col-sm-4 col-xs-4" style="padding-right: 5px;">
                      <select aria-label="Día" name="dia" id="dia" title="Día" class="form-control" v-model="dia">
                        <option value="">Día</option>
                        <option v-for="(item, index) in dias" :key="index" :value="item">
                          {{ item }}
                        </option>
                      </select>
                    </div>
                    <div class="col-sm-4 col-xs-4" style="padding-right: 5px; padding-left: 5px;">
                      <select aria-label="Mes" title="Mes" class="form-control" v-model="mes">
                        <option value="">Mes</option>
                        <option v-for="(item, index) in meses" :key="index" :value="index+1">
                          {{ item }}
                        </option>
                      </select>
                    </div>
                    <div class="col-sm-4 col-xs-4" style="padding-left: 5px;">
                      <select aria-label="Año" title="Año" class="form-control" v-model="ano">
                        <option value="">Año</option>
                        <option v-for="(item, index) in anos" :key="index" :value="item">
                          {{ item }}
                        </option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div v-if="vagon === 2 && candidato && !$apollo.loading">
              <h2 class="form-title">Registro</h2>
              <div class="alert alert-info form-alert text-center" role="alert">
                Para cualquier consulta sobre tus datos de inscripción contacta con <a href="mailto:acceso@uca.es">acceso@uca.es</a>
              </div>
              <div class="form-group row">
                <label for="dni" class="col-xs-5 col-form-label text-right">Documento:</label>
                <div class="col-sm-5 col-xs-7 text-left">
                  <input type="text" name="dni" id="dni" class="form-control" aria-label="Documento" disabled="disabled"
                         :value="candidato.letranif ? `${candidato.dni}${candidato.letranif}` : candidato.dni">
                </div>
              </div>
              <div class="form-group row">
                <label for="nombre" class="col-xs-5 col-form-label text-right">Nombre:</label>
                <div class="col-sm-5 col-xs-7 text-left">
                  <input type="text" name="nombre" id="nombre" class="form-control" aria-label="Nombre" disabled="disabled"
                         :value="candidato.nombre">
                </div>
              </div>
              <div class="form-group row">
                <label for="apellido1" class="col-xs-5 col-form-label text-right">Primer apellido:</label>
                <div class="col-sm-5 col-xs-7 text-left">
                  <input type="text" name="apellido1" id="apellido1" class="form-control" aria-label="Apellido 1" disabled="disabled"
                         :value="candidato.apellido1">
                </div>
              </div>
              <div class="form-group row">
                <label for="apellido2" class="col-xs-5 col-form-label text-right">Segundo apellido:</label>
                <div class="col-sm-5 col-xs-7 text-left">
                  <input type="text" name="apellido2" id="apellido2" class="form-control" aria-label="Apellido 2" disabled="disabled"
                         :value="candidato.apellido2">
                </div>
              </div>
              <div class="form-group row">
                <label for="numerosa" class="col-xs-5 col-form-label text-right">Familia numerosa:</label>
                <div class="col-sm-5 col-xs-7 text-left">
                  <input type="text" name="numerosa" id="numerosa" class="form-control" aria-label="Familia numerosa" disabled="disabled"
                         :value="candidato.familianumerosa === '4' ? 'Sí (categoría general)': candidato.familianumerosa === '5' ? 'Sí (categoría especial)' : 'No'">
                </div>
              </div>
              <div class="form-group row">
                <label for="discapacidad" class="col-xs-5 col-form-label text-right">Discapacidad:</label>
                <div class="col-sm-5 col-xs-7 text-left">
                  <input type="text" name="discapacidad" id="discapacidad" class="form-control" aria-label="Discapacidad" disabled="disabled"
                         :value="candidato.minusvalido ? 'Sí':'No'">
                </div>
              </div>
              <div class="form-group row">
                <label for="centro" class="col-xs-5 col-form-label text-right">Centro:</label>
                <div class="col-sm-5 col-xs-7 text-left">
                  <input type="text" name="centro" id="centro" class="form-control" aria-label="Centro" disabled="disabled"
                         :value="candidato.centro">
                </div>
              </div>
              <div class="alert alert-warning form-alert text-center" role="alert">
                <strong>MUY IMPORTANTE:</strong><br/>
                Introduce y confirma el correo electrónico y número de móvil <br/>
                donde recibirás todas las comunicaciones.
              </div>
              <div class="form-group row">
                <label for="email" class="col-xs-5 col-form-label text-right">Correo electrónico:</label>
                <div class="col-sm-5 col-xs-7 text-left">
                  <input type="text" name="email" id="email" class="form-control" aria-label="Correo electrónico" v-model="candidato.email">
                </div>
              </div>
              <div class="form-group row">
                <label for="email2" class="col-xs-5 col-form-label text-right">Confirmar correo:</label>
                <div class="col-sm-5 col-xs-7 text-left">
                  <input type="text" name="email2" id="email2" class="form-control" aria-label="Confirmar correo" v-model="email2"
                         onpaste="return false;">
                  <div class="rojo">{{aviso_email}}&nbsp;</div>
                </div>
              </div>

              <hr>

              <div class="form-group row">
                <label for="telefono" class="col-xs-5 col-form-label text-right">Teléfono móvil:</label>
                <div class="col-sm-5 col-xs-7 text-left">
                  <input type="text" name="telefono" id="telefono" class="form-control" aria-label="Teléfono móvil"
                         v-model="candidato.telefono">
                </div>
              </div>
              <div class="form-group row">
                <label for="telefono2" class="col-xs-5 col-form-label text-right">Confirmar móvil:</label>
                <div class="col-sm-5 col-xs-7 text-left">
                  <input type="text" name="telefono2" id="telefono2" class="form-control" aria-label="Confirmar móvil" v-model="telefono2"
                         onpaste="return false;">
                  <div class="rojo">{{aviso_telefono}}&nbsp;</div>
                </div>
              </div>
            </div>
            <div v-if="vagon === 3 && candidato">
              <h2 class="form-title">Confirmar y finalizar el registro</h2>
              <div class="alert alert-info form-alert text-center" role="alert">
                Para completar el proceso, si los datos son correctos, pulsa <strong>Finalizar registro</strong><br/>
                Te enviaremos la clave de acceso que usarás para todas las gestiones.<br/>
                No olvides comprobar también la carpeta de SPAM o correo no deseado.
              </div>
              <div class="alert alert-secondary text-center" role="alert">
                <strong>Destinatario de correo:</strong> <span class="destacado">{{candidato.email}}</span><br>
                <strong>Destinatario de SMS:</strong> <span class="destacado">{{candidato.telefono}}</span>
              </div>
            </div>
            <!-- BOTONERA -->
            <br/>
            <div v-if="!$apollo.loading && !cargando" class="form-group row">
              <div class="col-md-12 col-sm-12 col-xs-12 text-center">
                <button v-if="vagon === 3" class="btn btn-xtra-info" aria-label="Volver"
                        @click.prevent="atras"><i class="fa fa-backward"></i> Volver
                </button> &nbsp;
                <router-link :to="{name: 'menu-entrada'}" class="btn btn-danger" aria-label="Cancelar">
                  <i class="fa fa-times"></i> Cancelar
                </router-link> &nbsp;
                <button class="btn" :class="vagon === 3? 'btn-success intermitente':'btn-primary'" aria-label="Siguiente" :disabled="!puedo_seguir"
                        @click.prevent="siguiente">
                  <i class="fa fa-forward"></i> {{ vagon === 3 ? 'Finalizar registro' : 'Siguiente' }}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import gql from "graphql-tag";
import {quitarErrorGeneral} from "@/error";
import {obtenerSHA512} from "@/utils/hash";

export default {
  name: "Registro",
  data() {
    return {
      email2: '',
      telefono2: '',
      candidato: {},
      vagon: 1,
      cargando: 0,
      dni: '',
      dia: '',
      mes: '',
      ano: '',
      dias: Array.from({length: 31}, (v, i) => i + 1),
      meses: [
        'enero',
        'febrero',
        'marzo',
        'abril',
        'mayo',
        'junio',
        'julio',
        'agosto',
        'septiembre',
        'octubre',
        'noviembre',
        'diciembre'
      ],
      anos: Array.from(
          {length: new Date().getFullYear() - 10 - 1950 + 1},
          (_, i) => 1950 + i
      ),
    }
  },
  mounted() {
    quitarErrorGeneral();
  },
  apollo: {
    candidato: {
      query: gql`query($dni: String!, $dia: Int!, $mes: Int!, $ano: Int!) {
                candidato(dni: $dni, dia: $dia, mes: $mes, ano: $ano) {
                  dni
                  letranif
                  nombre
                  apellido1
                  apellido2
                  familianumerosa
                  minusvalido
                  centro
                  email
                  telefono
                  tokenRegistro
                  esCandidato
                }
            }`,
      variables() {
        return {
          dni: this.dni,
          dia: parseInt(this.dia),
          mes: parseInt(this.mes),
          ano: parseInt(this.ano),
        }
      },
      skip() {
        return this.vagon !== 2;
      },
      result(data) {
        if (!data.data.candidato) {
          this.$emit('aviso', 'No se encuentra ninguna inscripción para estos datos. Consulta con acceso@uca.es');
          this.vagon = 1;
        }
        else {
          if (!data.data.candidato.tokenRegistro) {
            this.$emit('aviso', 'Ya existe tu registro de usuario en la UCA. ' +
                'Utiliza la recuperación de clave o consulta con acceso@uca.es');
            this.$router.push({name: 'login'});
            this.vagon = 1;
          }
          else if (!data.data.candidato.esCandidato) {
            this.$emit('aviso', 'No es posible crear tu registro de usuario en la UCA. ' +
                'Utiliza la recuperación de clave o consulta con acceso@uca.es');
            this.$router.push({name: 'login'});
            this.vagon = 1;
          }
        }
        this.email2 = '';
        this.telefono2 = '';
      },
      error() {
        this.$emit('aviso', 'Ha habido un error. Prueba más tarde.');
        this.vagon = 1;
      },
    },
  },
  computed: {
    aviso_email() {
      if (this.candidato) {
        if (this.candidato.email) {
          if (this.candidato.email.trim() === this.email2.trim()) {
            if (/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(this.candidato.email.trim())) {
              if (/@(.*\.)?uca.es$/.test(this.candidato.email.trim())) {
                return 'El autorregistro no se permite con correo de la UCA';
              }
              else {
                return '';
              }
            } else {
              return 'Formato de correo incorrecto';
            }
          } else {
            return 'Los correos no coinciden';
          }
        }
        else {
          return 'El correo es obligatorio';
        }
      }
      else {
        return '';
      }
    },
    aviso_telefono() {
      if (this.candidato) {
        if (this.candidato.telefono) {
          if (this.candidato.telefono.trim() === this.telefono2.trim()) {
            if (/^(\+34)?([67])\d{8}$/.test(this.candidato.telefono.trim())) {
              return '';
            } else {
              return 'Formato de móvil no admitido';
            }
          } else {
            return 'Los números no coinciden';
          }
        }
        else {
          return 'El teléfono móvil es obligatorio';
        }
      }
      else {
        return '';
      }
    },
    puedo_seguir() {
      // Verifica que todos los campos del formulario estén rellenos y correctos
      return (this.vagon === 1 &&
              this.dni.trim() !== '' &&
              this.dia !== '' &&
              this.mes !== '' &&
              this.ano !== '')
          ||
          (this.vagon > 1 &&
              this.aviso_email === '' &&
              this.aviso_telefono === '');
    },
  },
  methods: {
    atras() {
      if (--this.vagon < 1)
        this.$router.push({name: 'login'});
    },
    async siguiente() {
      this.vagon++;
      if (this.vagon > 3) {
          this.cargando++;   // El $apollo.loading no funciona cuando se llama directamente con this.$apollo
          this.$apollo.mutate({
            mutation: gql`mutation($dni: String!, $email: String!, $telefono: String!, $hash: String!) {
              registraUsuario(dni: $dni, email: $email, telefono: $telefono, hash: $hash) {
                correcto
              }
            }`,
            variables: {
              dni: this.candidato.dni,
              email: this.candidato.email.trim(),
              telefono: this.candidato.telefono.trim(),
              hash: await obtenerSHA512(this.candidato.tokenRegistro + this.$cookies.get('csrftoken')),
            },
          }).then((data) => {
            if (data.data.registraUsuario.correcto) {
              this.$emit('aviso', 'Utiliza la clave que te hemos enviado para entrar a la matrícula. No olvides comprobar en tu correo electrónico la carpeta de SPAM.')
              this.$router.push({name: 'login'});
            }
            else {
              this.$emit('aviso', 'AVISO: Ha habido un error y no se ha creado el registro. Prueba más tarde.');
              this.vagon = 1;
            }
          }).catch(() => {
            this.$emit('aviso', 'AVISO: Ha habido un error y no se ha creado el registro. Prueba más tarde.');
            this.vagon = 1;
          }).finally(() => {
            this.cargando--;
          });
      }
    }
  }
}
</script>

<style scoped>

</style>